import { render, staticRenderFns } from "./DateLabel.vue?vue&type=template&id=52f649da&scoped=true"
import script from "./DateLabel.vue?vue&type=script&lang=js"
export * from "./DateLabel.vue?vue&type=script&lang=js"
import style0 from "./DateLabel.vue?vue&type=style&index=0&id=52f649da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f649da",
  null
  
)

export default component.exports